module.exports = __webpack_public_path__ + "static/amumu-93a46fef4dca638387da4db74b51a5d7.png";